import Logo from "../../../images/logo.png";
export const AuthBox = ({children}) => (
    <div className="setup-box">
        <div style={{"margin-bottom": "20px"}}><img src={Logo} height="60" className="logo" alt={'logo'}/></div>
        {children}</div>);

export const AuthIcon = ({src}) => (
  <div className="user">
    <img src={src} className="icon_user" width="100" alt={'user icon'}/>
  </div>
)

export const AuthContent = ({children}) => (<div className="setup-content">{children}</div>);

export const AuthButton = ({buttonEvent, buttonText}) => (
    <button className="btn_setup_next" onClick={buttonEvent}>{buttonText}</button>);

export const AuthBack = ({src}) => (<a href={src} className="link-back">Back to factor list</a>);

export const AuthQr = ({style, displayText, src, noBarCodeEvent, resend, qrTimeout, refreshCodeEvent}) => (

    <div style={style} className="qr-code clearfix">
        <div className="left">
            <p>{displayText}</p>
        </div>
        <div className="right">
            <div className="qr-box">
                {src && <img src={src} alt={src}/>}
                {resend && <div className="qr-error"></div>}
            </div>
            {!resend &&
            <span className="cannot-scan" onClick={noBarCodeEvent}>Can't scan?</span>}
            {resend &&
            <span className="cannot-scan" onClick={refreshCodeEvent}>Refresh Code</span>
            }
        </div>
    </div>);

export const AuthIntro = ({Icon, Title, Description, nextEvent}) =>
    (<AuthContent>
      <p>
        <strong>Set up multifactor authentication</strong>
      </p>
      <p>Your company requires multifactor authentication to add an additional layer of security when
          signing in to your Okta account.</p>
      <div className="google-authenticator clearfix">
          <img src={Icon} className="icon_GA" alt={Title}/>
          <div className="right">
              <p><strong>{Title}</strong></p>
              <p>{Description}</p>
              <button className="btn_setup" onClick={() => nextEvent()}>Setup</button>
          </div>
      </div>
    </AuthContent>);

export const AuthReButton = ({buttonEvent, buttonText}) => (
    <button className="btn_resend" onClick={buttonEvent}>{buttonText}</button>);
